import {
  Box,
  TextField,
  Typography,
  type TextFieldProps,
  type TypographyProps,
} from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  TextFieldProps: TextFieldProps;
  LabelProps?: TypographyProps;
  children?: JSX.Element;
  enableDarkTheme?: boolean;
}
export const SWTextField = ({
  name,
  label,
  TextFieldProps,
  LabelProps,
  children,
  placeholder,
  enableDarkTheme = false,
}: Props) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Box key={name}>
      {label && (
        <Typography
          variant="bodyBold"
          display="block"
          mb="4px"
          {...LabelProps}
          sx={{
            color: palette.textPrimary,
          }}
        >
          {label}
        </Typography>
      )}
      <TextField placeholder={placeholder} {...TextFieldProps} />
      {children}
    </Box>
  );
};
